import { wrapRootElement as wrap } from "./root-wrapper";
import "@fortawesome/fontawesome-svg-core/styles.css";

export const wrapRootElement = wrap;
